import { defineMessage } from 'services/localization';

export const messages = {
    addNewCompany: defineMessage('add_an_organisation'),
    noCompanyNoAdd: defineMessage('you_dont_have_a_company'),
    selectCompany: defineMessage('choose_a_company'),
};
